var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-5 p-5"},[_c('center',[_c('h1',{staticClass:"font-weight-bolder text-muted"},[_vm._v(_vm._s(_vm.header))]),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.details))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }